
















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class RemoveTemplateModal extends Vue {
    // Props
    @Prop({ default() { return {}; } })
    item!: any

    // Data
    dialog = false;
    loading = false;

    // Methods
    public async DeleteItem() {
        try {
            this.loading = true;
            this.item.remove();
            this.$emit('success');
            this.dialog = false;
        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.loading = false;
        }
    }

}
